import React, { useEffect, useState } from 'react';

import { ListItemButton, List, ListItemText } from '@mui/material';

import { Block } from 'components/page/Block';
import { SubTitle } from 'components/text';
import { useLojaColunasMenuAsideContext } from 'context/ConfiguracaoLojaColunasMenuAsideContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useGetGrupoExibicao } from 'pages/cadastro/secoes/hooks/useGetGrupoExibicao';

export function LojaFormSidebar() {
    const { data } = useGetGrupoExibicao();
    const { activeStep, listStep, setActiveStep, setListStep } = useLojaColunasMenuAsideContext();
    const { hasPermission } = usePermissionsContext();
    useEffect(() => {
        if (data) {
            setListStep(data.data);
        }
    }, [data]);
    return (
        <Block
            sx={{
                'width': '200px',
                'background': 'common.white',
                'height': '440px',
                'overflowY': 'scroll',
                '::-webkit-scrollbar': {
                    width: '2px',
                    height: '8px',
                },
                '::-webkit-scrollbar-track': {
                    backgroundColor: 'grey.200',
                },
                '::-webkit-scrollbar-thumb': {
                    backgroundColor: 'primary.main',
                    borderRadius: '2px',
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'grey.500',
                },
            }}
        >
            <SubTitle label="Seções" sx={{ my: 0 }} />

            <List component="nav">
                <ListItemButton
                    key={'dadosBasicos'}
                    selected={activeStep === 1}
                    onClick={() => setActiveStep(1)}
                    sx={{
                        padding: '0',
                        margin: '0',
                    }}
                >
                    <ListItemText primary={'Dados Básicos'} />
                </ListItemButton>
                {listStep?.map((item: any, index: number) => {
                    if (item.fgAtivo) {
                        return (
                            <ListItemButton
                                key={item.id || index}
                                selected={activeStep === item.idConfiguracaoPropriedadeGrupoExibicao}
                                disabled={!hasPermission(['LOJA_VISUALIZAR'])}
                                onClick={() => setActiveStep(item.idConfiguracaoPropriedadeGrupoExibicao)}
                                sx={{
                                    padding: '0',
                                    margin: '0',
                                }}
                            >
                                <ListItemText primary={item.dsConfiguracaoPropriedadeGrupoExibicao} />
                            </ListItemButton>
                        );
                    }
                })}
            </List>
        </Block>
    );
}
